import state from './state.js'
import actions from "./actions";
import mutations from './mutations.js'



export default {
    isRegistered: false,
    namespaced: true,
    mutations: mutations,
    state: state,
    actions: actions,
}
